module.exports = __webpack_public_path__ + "static/img/butterfluDownloadImg.165e1f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/butterfluDownloadImg.png
// module id = 4axO
// module chunks = 1